<template lang="html">

  <div>

    <div id="hey" v-if="$store.state.notification != null">
      <div class="notification" :class="'is-'+$store.state.notification.level">
        <button class="delete" @click="$store.commit('remove_notification')"></button>
        <div v-html="$store.state.notification.text"></div>
      </div>
    </div>
    <Notification></Notification>
    <!-- Menu burger visible sur mobile -->
    <button class="btn btn-primary d-md-none m-2 mb-4" @click="mobileSidebarVisibleHandle()">
      <i class="bi bi-list"></i>
    </button>
    <transition name="slide">
      <div v-if="mobileSidebarVisible" class="mobile-sidebar-overlay d-md-none">
        <div class="mobile-sidebar widder">
          <!-- même contenu que la sidebar normale -->
          <button class="btn-close" @click="mobileSidebarVisible = false"></button>
          <div class="menu">
            <div class="logo-image mb-4 ">
              <img class="logo-img" src="@/assets/img/logo/logo-light.svg"/>
            </div>

            <div class=" user position-relative "
                 data-bs-toggle="modal"
                 data-bs-target="#notif-modal">
                        <span class=" badge rounded-pill custom-badge"
                              :class="{'bg-danger': unread.length > 0, 'bg-primary': unread.length == 0 }">
                        {{ unread.length }}
                    </span>
              <img class="rounded-circle"
                   style="height: 40px !important; width: 40px !important;">
                   alt="profile"
                   :src="user.src"/>
              <div class="name text-white user-name">{{ user.fullname }}</div>

            </div>
            <ul class="menu-list-new mt-2">
              <li v-if="can_access.team" title="Team">
                <router-link class="router-link" to="/team" active-class="is-active">
                  <NavMenuItem text="Team" icon="icon-18 bi-people"></NavMenuItem>
                </router-link>
              </li>
              <li v-if="can_access.flow" title="Flow">
                <router-link class="router-link" to="/flow" active-class="is-active">
                  <NavMenuItem text="Flow" icon="icon-18 bi-list-check"></NavMenuItem>
                </router-link>
              </li>
              <li v-if="can_access.establishment" title="Établissements">
                <router-link class="router-link" to="/establishment" active-class="is-active">
                  <NavMenuItem text="Établissements" icon="icon-18 bi-shop"></NavMenuItem>
                </router-link>
              </li>
              <li v-if="can_access.manage" title="Statistiques">
                <router-link class="router-link" to="/manage" active-class="is-active">
                  <NavMenuItem text="Statistiques" icon="icon-18 bi-pie-chart"></NavMenuItem>
                </router-link>
              </li>
              <li v-if="can_access.lab" title="Laboratoire">
                <router-link class="router-link" to="/laboratory" active-class="is-active">
                  <NavMenuItem text="Laboratoire" icon="icon-18 bi-eyedropper"></NavMenuItem>
                </router-link>
              </li>
              <li v-if="can_access.debug">
                <router-link class="router-link" to="/about" active-class="is-active">
                  <NavMenuItem text="Debug" icon="fa-bug"></NavMenuItem>
                </router-link>
              </li>
              <li v-if="$store.state.profile != null && can_access.import_review" title="Import des avis">
                <router-link class="router-link" to="/profile" active-class="is-active">
                  <NavMenuItem text="Import des avis" icon="icon-18 bi-download">
                  </NavMenuItem>
                </router-link>
              </li>
              <li v-for="link in consultantLinks"
                  :key="link.uid"
                  :id="link.uid">
                <router-link
                    :to="{ name: 'consultantLinks', params: { uid: link.uid } }"
                    active-class="is-active"
                >
                  <NavMenuItem :text="link.label" :icon="'icon-18 ' + link.icon"/>
                </router-link>
              </li>
              <li>
                <a class="deco" v-on:click="logout" title="Déconnexion">
                  <NavMenuItem text="Déconnexion" icon="icon-18 bi-box-arrow-left"/>
                </a>
              </li>
            </ul>

            <div class="">
              <a v-if="$store.state.show_menu_text" class="pin">
                <img src="../assets/img/icons/lab.svg" @click="lockMenu()"/>
              </a>
              <a v-else class="pin">
                <img src="../assets/img/icons/lab-lock.svg" @click="lockMenu()"/>
              </a>
            </div>
          </div>

        </div>
      </div>
    </transition>
    <div class="layout-container d-flex">
      <aside class="menu-container d-none d-md-block px-2" style="width:150px; height: 100vh;"
             @mouseenter="showMenuTextOnHover"
             @mouseleave="hideMenuTextOnHover"
             :class="{'thinner': !show_menu_text, 'widder': show_menu_text}">
        <div class="menu">
          <div class="logo-image mb-4 ">
            <img class="logo-img" src="@/assets/img/logo/logo-light.svg"/>
          </div>

          <div class=" user position-relative "
               data-bs-toggle="modal"
               data-bs-target="#notif-modal">
                        <span class=" badge rounded-pill custom-badge"
                              :class="{'bg-danger': unread.length > 0, 'bg-primary': unread.length == 0 }">
                        {{ unread.length }}
                    </span>
            <img class="rounded-circle"
                 style="height: 40px !important; width: 40px !important;"
                 :src="user.src"/>
            <div class="name text-white user-name">{{ user.fullname }}</div>

          </div>
          <div class="d-flex flex-column gap-0">
            <!-- CARD 1: Likes & Dislikes -->
            <div class="card stat mb-3">
              <div class="px-2 py-0">
                <div class="d-flex justify-content-between align-items-center gap-2">
                  <div class="text-uppercase text-card">
                    <i class="bi bi-hand-thumbs-up"></i>
                  </div>
                  <div class="text-success">
                    {{ my_stats('positives_count') || 0 }}
                  </div>
                </div>
              </div>
            </div>
            <div class="card stat mb-3">
              <div class="px-2 py-0">
                <div class="d-flex justify-content-between align-items-center gap-2">
                  <div class="text-uppercase text-card">
                    <i class="bi bi-hand-thumbs-down"></i>
                  </div>
                  <div class="text-danger">
                    {{ my_stats('negatives_count') || 0 }}
                  </div>
                </div>
              </div>
            </div>

            <!-- CARD 2: Information needed -->
            <div class="card stat mb-3">
              <div class="px-2 py-0">
                <div class="row g-0">
                  <div class="text-center  d-flex justify-content-between align-items-center gap-2">
                    <div class="text-uppercase text-card">
                      <i class="bi bi-info-circle"></i>
                    </div>
                    <div class="text-warning">
                      {{ my_stats('informationneeded_count') || 0 }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- CARD 3: Validated -->
            <div class="card stat">
              <div class="px-2 py-0">
                <div class="row g-0">
                  <div class="text-center d-flex justify-content-between align-items-center gap-2">
                    <div class="text-uppercase text-card">
                      <i class="bi bi-check-circle"></i>
                    </div>
                    <div class="text-info">
                      {{ my_stats('validated_count') || 0 }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ul class="menu-list-new mt-2">
            <li v-if="can_access.team" title="Team">
              <router-link class="router-link" to="/team" active-class="is-active">
                <NavMenuItem text="Team" icon="icon-18 bi-people"></NavMenuItem>
              </router-link>
            </li>
            <li v-if="can_access.flow" title="Flow">
              <router-link class="router-link" to="/flow" active-class="is-active">
                <NavMenuItem text="Flow" icon="icon-18 bi-list-check"></NavMenuItem>
              </router-link>
            </li>
            <li v-if="can_access.establishment" title="Établissements">
              <router-link class="router-link" to="/establishment" active-class="is-active">
                <NavMenuItem text="Établissements" icon="icon-18 bi-shop"></NavMenuItem>
              </router-link>
            </li>
            <li v-if="can_access.manage" title="Statistiques">
              <router-link class="router-link" to="/manage" active-class="is-active">
                <NavMenuItem text="Statistiques" icon="icon-18 bi-pie-chart"/>
              </router-link>
            </li>
            <li v-if="can_access.lab" title="Laboratoire">
              <router-link class="router-link" to="/laboratory" active-class="is-active">
                <NavMenuItem text="Laboratoire" icon="icon-18 bi-eyedropper"/>
              </router-link>
            </li>
            <li v-if="can_access.debug">
              <router-link class="router-link" to="/about" active-class="is-active">
                <NavMenuItem text="Debug" icon="icon-18 bi-bug"/>
              </router-link>
            </li>
            <li v-if="$store.state.profile != null && can_access.import_review" title="Import des avis">
              <router-link class="router-link" to="/profile" active-class="is-active">
                <NavMenuItem text="Import des avis" icon="icon-18 bi-download"/>
              </router-link>
            </li>
            <li v-for="link in consultantLinks" :key="link.uid" :id="link.uid" title="Liens externes">
              <router-link
                  class="router-link"
                  :to="{ name: 'consultantLinks', params: { uid: link.uid } }"
                  active-class="is-active"
              >
                <NavMenuItem :text="link.label" text="Liens externes" :icon="'icon-18 ' + link.icon"/>
              </router-link>
            </li>
            <li>
              <a class="router-link" v-on:click="logout" title="Déconnexion">
                <NavMenuItem text="Déconnexion" icon="icon-18 bi-box-arrow-left">
                </NavMenuItem>
              </a>
            </li>
          </ul>

          <div class="menu-pin">
            <a @click="lockMenu()" class="pin">
              <i :class="!$store.state.show_menu_text ? 'bi bi-lock' : 'bi bi-unlock'"></i>
            </a>
          </div>
        </div>
      </aside>
      <main class="flex-grow-1" :class="(!mobileSidebarVisible) ? 'design' : ''"
            style="overflow-x: auto; margin-left: 70px">
        <router-view></router-view>
      </main>
    </div>
  </div>
</template>

<script>
import settings from '@/settings.coffee';
import NavMenuItem from '@/components/NavMenuItem';
import ConsultantStat from '@/components/ConsultantStat';
import Notification from '@/components/Notification';
import DropDown from '@/components/DropDown.vue';
import gql from '@/gqlService.coffee';
import queries from '@/gql/queries.coffee';

export default {
  name: 'home',
  components: {
    NavMenuItem,
    ConsultantStat,
    Notification
  },
  data() {
    return {
      mobileSidebarVisible: false,
      show_menu_text: false,
      consultant_stat_modal: false,
      notifications: new gql.DataHolder({
        model: 'notification_set',
        fields: 'uid title message done object_id',
        autoload: true,
        filters: {consultant: this.$store.state.profile.data.uid}
      }),
      consultantLinks: [],
      selectedLink: {label: null, href: null, icon: null},
      showing: '',
      iframeHeight: 500
    };
  },
  computed: {
    unread() {
      return this.notifications.results.filter((a) => !a.done);
    },
    can_access() {
      const ret = {
        team: false,
        flow: false,
        manage: false,
        establishment: false,
        debug: false,
        lab: false,
        import_review: false,
        links: false
      };
      if (this.$store.state.profile) {
        const perms = this.$store.state.profile.permissions;
        if (perms.includes('game.can_access_manage')) ret.manage = true;
        if (perms.includes('game.can_access_lab')) ret.lab = true;
        if (perms.includes('game.can_access_team')) ret.team = true;
        if (perms.includes('game.can_access_flow')) ret.flow = true;
        if (perms.includes('game.can_access_establishment')) ret.establishment = true;
        if (perms.includes('game.can_access_import_review')) ret.import_review = true;
        if (perms.includes('game.can_access_links')) ret.links = true;
      }
      return ret;
    },
    user() {
      const res = {
        src: '',
        fullname: ''
      };
      if (this.$store.state.profile.data.avatar) {
        res.src = settings.backendUrl + this.$store.state.profile.data.avatar;
      } else {
        res.src = '/img/icons/person-grey.svg';
      }
      res.fullname = this.$store.state.profile.data.fullname;
      return res;
    }
  },
  methods: {
    mobileSidebarVisibleHandle() {
      this.mobileSidebarVisible = !this.mobileSidebarVisible;
    },
    my_stats(key) {
      const statsArray = this.$store.state.stats || [];
      const stats = statsArray.reduce((acc, current) => {
        if (current.consultant_id === this.$store.state.profile.data.uid) {
          return current;
        }
        return acc;
      }, null);
      return stats ? stats[key] : null;
    },
    lockMenu() {
      this.$store.state.show_menu_text = !this.$store.state.show_menu_text;
      this.toggelMenuText(this.$store.state.show_menu_text);
    },
    open_consultant_stat_modal() {
      this.consultant_stat_modal = true;
    },
    toggelMenuText(show) {
      this.show_menu_text = show;
    },
    showMenuTextOnHover() {
      if (this.$store.state.show_menu_text) {
        this.toggelMenuText(true);
      }
    },
    hideMenuTextOnHover() {
      if (this.$store.state.show_menu_text) {
        this.toggelMenuText(false);
      }
    },
    logout() {
      this.$http.get(settings.authApiUrlLogout).then(() => {
        location.reload();
      });
    },
    async handleDataLoading() {
      this.establishments = await gql.query({
        model: 'establishment_set',
        filters: `consultant__uid:"${this.$store.state.profile.data.uid}"`,
        fields: 'uid name'
      });

      this.platforms = await gql.query({
        model: 'platform_set',
        fields: 'uid name'
      });

      const data = await queries.run('named_state_set');
      this.status_set = data.body.data.named_state_set;

      const r = await queries.run('get_consultant_links');
      if (r.ok) {
        this.consultantLinks = r.body.data.consultant_link_set;
        this.$store.state.consultant_link_set = this.consultantLinks;
      }
    }
  },
  async mounted() {
    await this.handleDataLoading();
  }
};
</script>


<style lang="scss" scoped>

option {
  padding: 20px; /* Espacement entre les options */
}

#hey {
  position: fixed;
  width: 300px;
  top: 20px;
  left: 20px;
  z-index: 3000;
}

.rotated {
  transform: rotate(45deg);
}

.thinner {
  max-width: 65px;
  transition: max-width 0.3s ease, width 0.3s ease;
}

.widder {
  max-width: 200px;
  width: 200px !important;
  transition: max-width 0.3s ease, width 0.3s ease;
}

.router-link {
  white-space: nowrap;
  max-height: 43px;
  overflow: hidden;
  text-overflow: unset;
}

.toggle {
  position: fixed;
  bottom: 10px;
  left: 10px;
}

.menu-container {
  background-color: rgb(124, 156, 156);
  border-bottom-right-radius: 16px;
  border-top-right-radius: 16px;
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  z-index: 1000;
  transition: max-width 0.3s ease, width 0.3s ease;
  overflow-x: hidden;
}

.logo-image {
  margin-bottom: 0;
  text-align: initial;
  width: 180px;
  margin-left: 0px;
  display: inline;

  img,
  .logo-img {
    margin-top: 12px;
    min-height: 50px;
    min-width: 50px;
    max-width: 175px;
    object-position: left;
    object-fit: cover;
    transition: width var(--transition-time), height var(--transition-time);
  }

  .logo-img {
    background-repeat: no-repeat;
  }
}

li {
  box-sizing: border-box;
  position: relative;
  margin-bottom: 0px;
  height: 45px;
}

li > a, a.deco {
  border-radius: var(--border-radius-lg);
  width: 100%;
  color: var(--light-text);
  transition: color var(--transition-time);
  padding: 0.5rem 0.8rem;
  padding-left: 15px;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-height: 43px;
  overflow: hidden;

}

li > a:hover {
  background: rgba(var(--light-text-rgb), 0.1);

}

li > a.is-active {
  background: rgba(var(--light-text-rgb), 0.1);
}

a.pin {
  position: absolute;
  bottom: 0;
  border-radius: var(--border-radius-lg);
  color: var(--light-text);
  transition: color var(--transition-time);
  padding: 0.5rem 0.8rem;
  display: inline-block;
}

a.pin:hover {
  background: rgba(var(--light-text-rgb), 0.1);

}

.user {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 0.5em;
  margin-top: 1em;

  cursor: pointer;
}

.design {
  margin-left: 60px;
}

.user-name {
  white-space: nowrap;
  text-overflow: ellipsis;
  max-height: 25px;
  overflow: hidden;
}

.thinner > * > * > .user-name {
  display: none_;
  opacity: 0%;
}

.custom-badge {
  margin-bottom: -5px;
  font-size: 11px;
  z-index: 10;
}

.text-card {
  font-size: 9.8px;
}

.mobile-sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1000;
}

.mobile-sidebar {
  background: rgb(124, 156, 156);
  width: 250px;
  height: 100%;
  overflow-y: auto;
  padding: 20px;
}

a.pin {
  position: absolute;
  bottom: 0;
  padding: 0.5rem 0.8rem;
  display: inline-block;
}
</style>

